import { useEffect } from 'react';

/**
 * Landing page GitHub redirects to after authorization. Runs inside the
 * popup opened by AuthModal — hands the auth code back to the opener via
 * postMessage and closes itself, so the opener never navigates away.
 */
const GithubCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      source: 'github-oauth',
      code: params.get('code'),
      state: params.get('state'),
      error: params.get('error'),
    };

    if (window.opener) {
      window.opener.postMessage(payload, window.location.origin);
    }
    window.close();
  }, []);

  return null;
};

export default GithubCallback;
